import api from 'base/utils/api';
import {
    CartDataType,
    IApiCartList,
    IBonusProdListData,
    IUpdateCartItemNumRes,
    SummaryPriceType
} from '@base/cart/interface';
import { IProduct } from 'base/interfaces/product';
import { filterProductsFields } from 'base/utils/product';

// 获取购物车列表
export const fetchCartList = (): Promise<CartDataType> => {
    return api.post('/web/cart/v3/list', {
        data: {}
    });
};
// 选中/取消选中购物车商品
export const selectCartItem = (ids: string[]): Promise<void> => {
    return api.post('/web/cart/v3/select', {
        data: { cartItemIds: ids }
    })
}

//计算价格
export function fetchSummary(): Promise<SummaryPriceType> {
    return api.post('/web/cart/v2/calculate', {
        data: {}
    }).catch(() => null);
}

//修改购物车商品的数量
export function updateCartItemNum(cartItemId: string, cartItemNum: number): Promise<IUpdateCartItemNumRes> {
    return api.post('/web/cart/update-cart-item-num', {
        data: {
            cartItemId,
            cartItemNum,
        }
    })
}

//删除购物车
export function deleteCartItem(cartItemId: string): Promise<null> {
    // return api.post('/api/success', {
    //     data: {
    //         cartItemId
    //     }
    // });
    return api.post('/web/cart/delete-cart-item', {
        data: {
            cartItemId
        }
    })
}

//You May Want To Add
export function getCartRecommend(): Promise<IProduct[]> {
    return api.get('/web/featureConfig/getCartRecommend', {
        params: {
            name: 'Cart Recommendation'
        }
    }).then(res => filterProductsFields(res.variants))
}

//批量删除
export function batchDelete(cartItemIds: string[]): Promise<null> {
    return api.post('/web/cart/delete-cart-item', {
        data: {
            cartItemIds
        }
    })
}

// 检查有效 跳转购物车
export function checkGroupValid(cartItems: string[]): Promise<null> {
    return api.post('/web/cart/v2/checkGroupValid', {
        data: {
            cartItems: cartItems
        }
    })
}

// 获取加购商品列表
export function fetchBonusProdList(): Promise<IBonusProdListData> {
    return api.get('/web/cart/v3/bonusItem')
}

// 获取加购商品列表 v2
export function fetchBonusItemList(): Promise<IBonusProdListData> {
    return api.get('/web/bonus/item/list')
}